module.exports = __webpack_public_path__ + "img/cww_05.63ffd02f.jpg";